import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=60105d06&scoped=true"
import script from "./BrandSelect.vue?vue&type=script&lang=js"
export * from "./BrandSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60105d06",
  null
  
)

export default component.exports